<template>
  <layout name="BaseLayout">
    <div>
      <v-data-table ref="dataTable" dense :headers="tableHeaders" :items="items" :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc" class="elevation-1" :loading="loading" :loading-text="loadingText" :footer-props="{
          itemsPerPageOptions: rowsPerPage,
          itemsPerPageAllText: allTextForPerPage,
          itemsPerPageText: itemsPerPageText,
        }" :options="options" :no-results-text="filtersNoResultText" :multi-sort="false">
        <!-- formatear el texto de la paginacion -->
        <template v-slot:footer.page-text="props">
          {{ props.pageStart }} - {{ props.pageStop }} de
          {{ props.itemsLength }}
        </template>

        <!-- cabecera (toolbar + filtros) antes del header de la tabla -->
        <template v-slot:top>
          <v-toolbar text color="white">
            <v-toolbar-title>Personas</v-toolbar-title>

            <v-divider class="mx-4" inset vertical></v-divider>

            <v-btn :loading="loading" :disabled="loading || !canSearch()" @click="refreshItems" text color="primary">
              Actualizar
              <v-icon right dark>mdi-refresh</v-icon>
            </v-btn>
          </v-toolbar>

          <!-- Filtros -->
          <v-container fluid>
            <v-row class="pl-3 pr-3 pt-1">
              <!-- Filtrar Buscador TEST-->
              <v-col class="pt-0 pb-0" cols="4">
                <v-text-field prepend-icon="mdi-magnify" class="pt-0 pb-0" v-model="search" type="text" label="Busqueda"
                  clearable hint="Mínimo 3 caracteres." persistent-hint></v-text-field>
              </v-col>

              <v-btn :loading="loading" :disabled="loading || !canSearch()" @click="buscar" text color="primary">
                Buscar
              </v-btn>
            </v-row>
          </v-container>
          <!-- ./Filtros-->
        </template>

        <!-- columna de acciones -->
        <template v-slot:item.actions="{ item }">
          <!-- acceso al detalle -->
          <v-btn small color="primary" icon @click="editItem(item)">
            <v-icon small>
              mdi-cog
            </v-icon>
          </v-btn>

          <!-- imprimir ficha -->
          <v-btn small color="primary" icon @click="downloadFicha(item)"
            :loading="loadingDownloadFicha && isCurrentItemFichaLoading(item)"
            :disabled="loadingDownloadFicha && !isCurrentItemFichaLoading(item)">
            <v-icon small>
              mdi-clipboard-account-outline
            </v-icon>
          </v-btn>

          <!-- imprimir carnet -->
          <v-btn v-if="item.esAlumno" small color="primary" icon @click="downloadCarnet(item)"
            :loading="loadingDownloadCarnet && isCurrentItemCarnetLoading(item)" :disabled="loadingDownloadCarnet && !isCurrentItemCarnetLoading(item)
              ">
            <v-icon small>
              mdi-card-account-details-outline
            </v-icon>
          </v-btn>
        </template>

        <!-- Se muestra con resultado vacio -->
        <template v-slot:no-data>
          {{ filtersNoResultText }}
        </template>
      </v-data-table>

      <!-- Edicion fullscreen -->
      <template>
        <v-row justify="center">
          <v-dialog v-model="dialogPersona" fullscreen hide-overlay transition="dialog-bottom-transition">
            <v-card>
              <!-- cabecera full screen -->
              <v-toolbar dark color="primary">
                <v-btn icon dark @click="closeDialogPersona">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>Configurar persona</v-toolbar-title>
              </v-toolbar>

              <!-- contenido fullscreen -->
              <v-tabs v-model="tab" background-color="transparent" color="primary" grow @change="changeTab">
                <v-tab v-for="(tabItem, index) in tabItems" :key="index">
                  {{ tabItem.title }}
                </v-tab>
              </v-tabs>

              <v-tabs-items v-model="tab">
                <v-tab-item v-for="(tabItem, index) in tabItems" :key="index">
                  <!-- formulario datos personales -->
                  <template v-if="tabItem.type == 'persona' && editedItem != null">
                    <component :key="editDialogComponentsKey" :is="tabItem.component"
                      v-bind="{ item: editedItem, userCanEdit }" @submitPersona="updatePersona"></component>
                  </template>

                  <!-- historial del alumno -->
                  <template v-if="tabItem.type == 'historial' &&
                    editedItem != null &&
                    editedItem.esAlumno
                    ">
                    <component :key="editDialogComponentsKey" :is="tabItem.component"
                      v-bind="{ item: editedItem, userCanEdit }"></component>
                  </template>
                </v-tab-item>
              </v-tabs-items>
            </v-card>
          </v-dialog>
        </v-row>
      </template>
    </div>
  </layout>
</template>

<script>
import Layout from "@/components/layouts/Layout";
import { mapGetters, mapMutations } from "vuex";
import { getPersonas, getFicha } from "@/api/personas.api";
import { getListado } from "@/api/tiposPdf.api";
import PersonaForm from "@/components/persona/PersonaForm";
import HistorialAlumno from "@/components/persona/HistorialAlumno";

export default {
  name: "Personas",
  components: {
    Layout,
    PersonaForm,
    HistorialAlumno,
  },

  data: () => ({
    items: [],
    headers: [],
    sortBy: "nombre",
    sortDesc: false,
    rowsPerPage: [25, 50, 75, 100, -1],
    options: {
      itemsPerPage: 25,
    },
    search: "",

    loading: false,
    loadingDownloadCarnet: false,
    loadingDownloadCarnetActionRef: "",
    loadingDownloadFicha: false,
    loadingDownloadFichaActionRef: "",

    // dialog edicion y tabs
    dialogPersona: false,
    editedItem: null,
    editDialogComponentsKey: 0,
    tab: 0,
    tabItems: [],

    // textos varios
    filtersNoResultText: "No se han encontrado resultados",
    loadingText: "Cargando ...",
    itemsPerPageText: "Filas por página:",
    allTextForPerPage: "Todas",

    // Administracion de roles de usuario
    authorizedRoles: ["ROLE_SUPER_ADMIN"],
  }),

  beforeMount() {
    if (
      this.$store.getters["Auth/authRoles"] !== undefined &&
      !this.authorizedRoles.includes(this.$store.getters["Auth/authRoles"][0])
    ) {
      this.loading = false;
      this.$router.push("/prematriculas");
    }
  },

  created() {
    this.initialize();
  },

  watch: {
    editedItem() {
      if (this.editedItem == null && this.tabItems.length > 1) {
        this.tabItems.splice(1, 1);
      } else if (this.editedItem != null) {
        // no es alumno y tenemos el tab de historial se borra
        if (!this.editedItem.esAlumno && this.tabItems.length > 1) {
          this.tabItems.splice(1, 1);
        }

        // es alumno si no está el tab de hitorial lo añadimos
        if (this.editedItem.esAlumno && this.tabItems.length < 2) {
          this.tabItems.push({
            title: "Historial del Alumno",
            type: "historial",
            component: "historial-alumno",
          });
        }
      }
    },
  },

  computed: {
    ...mapGetters("App", {
      cursoActual: "GET_CURSO_ACTUAL",
    }),

    ...mapGetters("Auth", {
      userCanEdit: "userCanEdit",
    }),

    tableHeaders() {
      return this.headers;
    },
  },

  methods: {
    ...mapMutations("Snack", {
      setSnack: "SET_SNACK_OPTIONS",
    }),

    async initialize() {
      this.loading = true;

      this.headers = [
        { text: "Nº Persona", align: "start", value: "id" },
        {
          text: "Apellidos y nombre",
          align: "start",
          value: "nombre",
        },
        {
          text: "DNI",
          align: "start",
          value: "dni",
        },
        {
          text: "Email",
          align: "start",
          value: "email",
        },
        {
          text: "Teléfono",
          align: "start",
          value: "telefono",
        },
      ];

      if (this.userCanEdit) {
        this.headers.push({ text: "", value: "actions", sortable: false });
      }

      // cargar tab datos personales
      this.tabItems = [
        {
          title: "Datos personales",
          type: "persona",
          component: "persona-form",
        },
      ];

      this.loading = false;
    },

    async refreshItems() {
      if (this.search == null || this.search.length < 3) {
        this.items = [];
      } else {
        this.loading = true;
        await getPersonas(this.search).then((response) => {
          this.items = response.data;
        });
        this.loading = false;
      }
      this.loading = false;
    },

    editItem(item) {
      // setear el item seleccionado para la edicion
      this.editedItem = Object.assign({}, item);

      // abrir dialog
      this.dialogPersona = true;
    },

    async downloadCarnet(item) {
      this.loadingDownloadCarnetActionRef = `btn-carnet-${item.id}`;
      this.loadingDownloadCarnet = true;

      const filename = this.generateCarnetFilename(item);
      const queryOptions = { codigoPersona: item.codigo };
      const tipo = { id: 6 };

      await getListado(tipo, queryOptions).then(function (response) {
        let b64 = response.data.output;

        // Insert a link that allows the user to download the PDF file
        var link = document.createElement("a");
        link.href = "data:application/octet-stream;base64," + b64;
        link.download = `${filename}.pdf`;
        link.click();
      });

      this.loadingDownloadCarnet = false;
    },

    generateCarnetFilename(item) {
      return this.generateFileName("carnet", item);
    },

    generateFichaFilename(item) {
      return this.generateFileName("ficha", item);
    },

    generateFileName(tipo, item) {
      let nombre = item.nombre;
      nombre = this.sanitize(nombre);
      return `${tipo}-${item.id}-${nombre}`;
    },

    sanitize(string) {
      return string
        .toLowerCase()
        .replace(/[^a-z]/gi, "_")
        .trim();
    },

    isCurrentItemCarnetLoading(item) {
      return this.loadingDownloadCarnetActionRef == `btn-carnet-${item.id}`;
    },

    async downloadFicha(item) {
      this.loadingDownloadFichaActionRef = `btn-ficha-${item.id}`;
      this.loadingDownloadFicha = true;
      const filename = this.generateFichaFilename(item);

      await getFicha(item.id).then(function (response) {
        let b64 = response.data.output;

        // Insert a link that allows the user to download the PDF file
        var link = document.createElement("a");
        link.href = "data:application/octet-stream;base64," + b64;
        link.download = `${filename}.pdf`;
        link.click();
      });

      this.loadingDownloadFicha = false;
    },

    isCurrentItemFichaLoading(item) {
      return this.loadingDownloadFichaActionRef == `btn-ficha-${item.id}`;
    },

    async buscar() {
      if (this.search == null || this.search.length < 3) {
        this.items = [];
      } else {
        this.loading = true;
        await getPersonas(this.search).then((response) => {
          this.items = response.data;
        });
        this.loading = false;
      }
    },

    canSearch() {
      return this.search != null && this.search.length > 2;
    },

    /**
     * Cierra el dialog y reinicia los valores del tab activo y
     * el item cargado anteriormente
     */

    closeDialogPersona() {
      this.dialogPersona = false;
      this.changeTab(0);
      this.editedItem = null;
    },

    changeTab(tabIndex) {
      this.tab = tabIndex;
    },

    updatePersona(event, response) {
      if (response.status == 200) {
        let item = response.data;

        // Buscar el indice del item de la tabla
        let filtered = this.items.reduce((acc, tableItem, index) => {
          if (tableItem.id === item.id) {
            acc.push(index);
          }
          return acc;
        }, []);

        // actualizar los registros de la tabla
        filtered.map((index) => {
          this.items[index].fechaNacimiento = item.fechaNacimiento;
          this.items[index].dni = item.dni;
          this.items[index].nombre = item.nombre;
          this.items[index].email = item.email;
          this.items[index].telefono = item.telefono;
          this.items[index].telefono2 = item.telefono2;
          this.items[index].direccion = item.direccion;
          this.items[index].codigoPostal = item.codigoPostal;
          this.items[index].poblacion = item.poblacion;
          this.items[index].provincia = item.provincia;
          this.items[index].observaciones = item.observaciones;
        });

        this.setSnack({
          active: true,
          timeout: 1500,
          color: this.$getStringFor("snack", "successColor"),
          text: this.$getStringFor("snack", "successText"),
        });
      } else {
        this.setSnack({
          active: true,
          timeout: 1500,
          color: this.$getStringFor("snack", "errorColor"),
          text: this.$getStringFor("snack", "errorText"),
        });
      }
    },
  },
};
</script>
